import { UpgradeRegistryItem } from '../upgrader.types'
/**
 * component 对应组件类型
 * form 从某个版本开始升级
 * to 升级到的版本
 * upgrade 升级方法
 */
export const hhButtonWidgetUpgrades: UpgradeRegistryItem = {
  component: 'HHButtonWidge',
  upgrades: []
}
